export const CHART_COLOR = [
    '#528EFF',
    '#57D9D4',
    '#8F5CFF',
    '#FFC27D',
    '#F25788',
    '#0099E6',
    '#FF908C',
    '#7BD964',
    '#4D4DFF',
    '#FFE030',
    '#A8CAFF',
    '#00BFBF',
    '#B8BBFF',
    '#FF9326',
    '#FFADC5',
    '#69D2FF',
    '#FF6966',
    '#30BF13',
    '#9497FF',
    '#FAD000'
];

export const CHART_DATA_ZOOM = {
    type: 'slider',
    height: 8,
    handleSize: '100%',
    moveHandleSize: 0,
    backgroundColor: '#F2F2F3',
    borderRadius: 0,
    borderColor: '#F2F2F3',
    fillerColor: '#D3E0FC',
    handleIcon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAACNJREFUGJVjVMn49J+BCMBEjCIMhben82Jlk28iVRQyUt3XAJ4OCAdE/x0HAAAAAElFTkSuQmCC',
    dataBackground: {
        areaStyle: {
            opacity: 0
        },
        lineStyle: {
            opacity: 0
        }
    },
    selectedDataBackground: {
        areaStyle: {
            opacity: 0
        },
        lineStyle: {
            opacity: 0
        }
    },
    emphasis: {
        handleStyle: {
            shadowColor: '#2468F2',
            shadowBlur: 8
        }
    }
};

export const getAxisLabel = (isShortTime = false) => {
    const dateFormat = isShortTime ? '{MM}-{dd}' : '{yyyy}-{MM}-{dd}';
    const timeFormat = isShortTime ? '{HH}:{mm}' : '{HH}:{mm}:{ss}';
    return {
        hideOverlap: true,
        formatter: {
            year: dateFormat,
            month: dateFormat,
            day: dateFormat,
            hour: timeFormat,
            minute: timeFormat,
            second: timeFormat
        }
    };
};